import styled from 'styled-components';

export const CloudPouchWrapper = styled.section`
  padding: 80px 0;
  background: #fff;
  @media (max-width: 990px) {
    padding: 60px 0;
  }
  @media (max-width: 767px) {
    padding: 40px 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 480px;
  margin-left: auto;
  @media (max-width: 990px) {
    margin-left: 0;
  }
  a {
    color: #46679f;
    font-weight: 600;
    text-decoration: underline;
    &:hover {
      color: #0f2137;
    }
  }
`;

export const BookImage = styled.img`
  display: block;
  width: 100%;
  max-width: 480px;
  height: auto;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 0 20px 45px rgba(15, 33, 55, 0.15);
`;
